<div [ngClass]="{ 'black-panel': openFilter, panel: !openFilter }">
  <mat-expansion-panel class="filter-position" [attr.expanded]="openFilter" (opened)="openEvent()" (closed)="closeEvent()">
    <mat-expansion-panel-header class="filt-custom">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-9">
            <mat-chip-listbox>
              <mat-chip *ngFor="let f of filtersMap">{{ f.filter }}</mat-chip>
            </mat-chip-listbox>
          </div>
          <div class="col-md-2">
            <mat-panel-title class="filter-title"> Filters </mat-panel-title>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="container-fluid">
      <div class="row pt-3">
        <div class="filter-box col-md-12 text-light-secondary margin-top-5">
          <div class="row justify-content-center row-cols-4">
            <div class="col">
              <mat-form-field>
                <mat-select [(ngModel)]="filters.operationType" placeholder="Type">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let t of operationTypes" [value]="t">{{ t }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.documentNumber" placeholder="Document Number" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <mat-select [(ngModel)]="filters.logisticPartner" placeholder="Logistic Partner" filterKey="name">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let lp of logisticPartners" [value]="lp">{{ lp }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <mat-select [(ngModel)]="filters.client" placeholder="Client">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let cl of clients" [value]="cl">{{ cl }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <app-brandon-autocomplete label="Status" [allData]="statusList" [(value)]="filters.status"></app-brandon-autocomplete>
            </div>
            <div class="col">
              <mat-form-field>
                <mat-select [(ngModel)]="filters.orderType" placeholder="Order Type">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let bl of orderTypes" [value]="bl">{{ bl }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <app-brandon-autocomplete
                label="Supplier"
                [allData]="suppliers"
                [(value)]="filters.supplierCode"
                filterKey="description"
                displayKey="description"
                valueKey="code"
              ></app-brandon-autocomplete>
            </div>
            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.customerOrderReference" placeholder="Customer order number" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <textarea matInput [(ngModel)]="operationIdsString" placeholder="Operation IDs"></textarea>
              </mat-form-field>
            </div>
            <div class="col">
              <app-brandon-autocomplete
                label="Warehouse"
                [allData]="warehouses"
                [(value)]="filters.warehouse"
                filterKey="name"
                displayKey="name"
                valueKey="code"
              ></app-brandon-autocomplete>
            </div>
            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.carrier" placeholder="Carrier" oninput="this.value = this.value.toUpperCase()" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="latestShipDateFrom"
                  [(ngModel)]="filters.latestShipDateFrom"
                  placeholder="Latest Ship Date from"
                />
                <mat-datepicker-toggle matSuffix [for]="latestShipDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #latestShipDateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="latestShipDateTo"
                  [(ngModel)]="filters.latestShipDateTo"
                  placeholder="Latest Ship Date to"
                />
                <mat-datepicker-toggle matSuffix [for]="latestShipDateTo"></mat-datepicker-toggle>
                <mat-datepicker #latestShipDateTo></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.partnerStatus" placeholder="Partner Status" />
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.sku" placeholder="Sku" />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-md-12 border-top-white text-center">
          <button type="submit" (click)="onSubmitFilter()">Filter</button>
          <button type="button" (click)="resetFilters()">Reset</button>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</div>
